export default __webpack_public_path__ + "static/1-36-0-universal-search-ab60bb434964f4f0ec422062b266eea5.png";